<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b>80 Days of Pleasure</b></p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">Text copyright @ 2021 by Words to Ponder Publishing Company, LLC</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">.</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Cover Design by J. L. Woodson for Woodson Creative Studio.</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Interior Design by Lissa Woodson for Woodson Creative Studio</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">First Print</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">This book is protected under the copyright laws of the United States and other countries throughout the world. Names, characters, and incidents portrayed are fictitious. No identification with actual persons (living or deceased), places, buildings, or products are intended or should be inferred.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">All rights reserved. No part of this book, or the characters within it, may be reproduced or transmitted in any form or by any mechanical means, including information storage and retrieval systems, without written permission from the publisher, Words to Ponder Publishing Company, LLC, except by reviewer, who may quote passages in a review.</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Address inquiries to Words to Ponder Publishing Company, LLC</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left copyright-content">Trade Paperback ISBN 978-1-7358795-9-8</p>
<p class="alignment-block-content alignment-block-content-left copyright-content">Ebook ISBN 978-1-941328-56-9</p>
</div>
</div>
<div class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-square inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="Words to Ponder Logo" src="images/image1.jpg"/>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Words to Ponder Publishing Company, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Printed in the United States of America</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">For more information, visit <a class="content-external-link text-is-url" href="https://www.florenza.org" target="_blank">https://www.florenza.org</a> or</p>
<p class="alignment-block-content alignment-block-content-center copyright-content"><a class="content-external-link" href="https://www.wordstoponderpublishing.com" target="_blank">https://www.wordstoponderpublishing.com.</a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5190aed8